// Service worker rimasti registrati nel browser che il server non serve più, e che a ogni controllo di aggiornamento ricevono l'HTML dell'app
// (`SecurityError: ... unsupported MIME type ('text/html')`):
// - in produzione: `/sw.js`, il vecchio worker standalone eliminato il 03/11/2026 (resta valido `/sw-notifications.js`, quello compilato dalla build);
// - in sviluppo: tutti. Il service worker in sviluppo è spento (`config/pwa.config.js`), quindi qualunque registrazione sulla stessa origine (localhost:8905)
//   è un residuo: una prova della build di produzione, il vecchio `/sw.js` o un `/dev-sw.js` rimasto «trying to install».

const PERCORSI_OBSOLETI = ["/sw.js"];

function eObsoleta(registrazione: ServiceWorkerRegistration, percorsi: readonly string[]): boolean {
  const worker = registrazione.active ?? registrazione.waiting ?? registrazione.installing;
  if (!worker) return false;
  try {
    return percorsi.includes(new URL(worker.scriptURL).pathname);
  } catch {
    return false;
  }
}

/**
 * Disiscrive le registrazioni obsolete (in sviluppo tutte) e restituisce quelle ancora valide. Non lancia mai: serve all'avvio, prima di aggiornare e prima
 * di iscriversi alle notifiche.
 */
export async function rimuoviServiceWorkerObsoleti(inSviluppo: boolean = import.meta.dev): Promise<ServiceWorkerRegistration[]> {
  const registrazioni = (await navigator.serviceWorker?.getRegistrations?.()) ?? [];
  const valide: ServiceWorkerRegistration[] = [];
  for (const registrazione of registrazioni) {
    if (!inSviluppo && !eObsoleta(registrazione, PERCORSI_OBSOLETI)) {
      valide.push(registrazione);
      continue;
    }
    try {
      await registrazione.unregister();
    } catch (errore) {
      console.warn("[service worker] impossibile rimuovere la registrazione obsoleta:", errore);
    }
  }
  return valide;
}
